export const AUTH_COOKIE_KEY = 'workshop_auth_token';

export const setAuthToken = (token: string, expiresInSeconds = 60 * 60): void => {
  const expires = new Date(Date.now() + expiresInSeconds * 1000).toUTCString();
  document.cookie = `${AUTH_COOKIE_KEY}=${encodeURIComponent(
    token,
  )}; path=/; expires=${expires}; SameSite=Lax`;
};

export const clearAuthToken = (): void => {
  document.cookie = `${AUTH_COOKIE_KEY}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`;
};

export const getAuthToken = (): string | null => {
  const match = document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(`${AUTH_COOKIE_KEY}=`));

  if (!match) {
    return null;
  }

  return decodeURIComponent(match.split('=')[1]);
};
